import React from 'react';
import { registerWidget } from '@okapi/core';
import {
  SavedProjectConfiguration,
  SavedProjectConfigurationProps,
  SavedProjectConfigurationState,
} from 'entries/common/widgets';
import { createApi } from 'utils/api';

registerWidget<SavedProjectConfigurationProps, SavedProjectConfigurationState>(
  `${__NAME__}/savedProjectConfiguration`,
  state => props => {
    const host = state.env.ORCHESTRATOR_HOST;
    const apiKey = state.env.API_KEY;
    const api = createApi(host, apiKey);
    return <SavedProjectConfiguration {...state} {...props} api={api} />;
  }
);
